import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreatInvestigation = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.894 18.144L23.25 22.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 12H7.268C7.33769 12 7.40601 11.9807 7.46534 11.9441C7.52467 11.9076 7.57268 11.8552 7.604 11.793L9.377 8.247C9.40936 8.18249 9.45965 8.1287 9.52183 8.09206C9.58401 8.05543 9.65543 8.03752 9.72754 8.04048C9.79965 8.04343 9.86937 8.06713 9.92834 8.10873C9.98731 8.15033 10.033 8.20806 10.06 8.275L12.46 14.275C12.4863 14.3403 12.5304 14.3969 12.5873 14.4383C12.6442 14.4797 12.7116 14.5042 12.7818 14.5092C12.852 14.5141 12.9222 14.4991 12.9843 14.466C13.0464 14.4329 13.0979 14.383 13.133 14.322L15.447 10.273C15.4787 10.2174 15.5241 10.1709 15.5788 10.1378C15.6336 10.1047 15.6959 10.0861 15.7599 10.0839C15.8238 10.0817 15.8873 10.0959 15.9442 10.1252C16.0011 10.1544 16.0496 10.1977 16.085 10.251L17.25 12",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.72 8.25C3.41275 6.10614 4.82651 4.26832 6.72099 3.0489C8.61547 1.82949 10.8738 1.30373 13.112 1.56099C15.3503 1.81825 17.4304 2.84265 18.9989 4.46008C20.5673 6.07751 21.5272 8.18816 21.7155 10.4333C21.9038 12.6784 21.3088 14.9195 20.0317 16.7755C18.7546 18.6316 16.8742 19.9882 14.71 20.6147C12.5459 21.2411 10.2315 21.0989 8.16041 20.212C6.08928 19.3252 4.38916 17.7485 3.349 15.75",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgThreatInvestigation;
